import { FaFacebook, FaXTwitter, FaPinterest } from "react-icons/fa6";

interface SocialShareProps {
  url: string;
  title: string;
  description?: string;
  image?: string;
}

export const SocialShare = ({ url, title, description, image }: SocialShareProps) => {
  // Encode parameters for URLs
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const encodedDescription = encodeURIComponent(description || "");
  const encodedImage = encodeURIComponent(image || "");

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    pinterest: `https://pinterest.com/pin/create/button/?url=${encodedUrl}&description=${encodedDescription}&media=${encodedImage}`,
  };

  const handleShare = (platform: string) => {
    const shareUrl = shareLinks[platform as keyof typeof shareLinks];

    // Instagram requires a different approach as it doesn't support direct URL sharing
    if (platform === "instagram") {
      // Could show a message about copying the link instead
      navigator.clipboard.writeText(url);
      alert("Link copied! Share it on Instagram.");
      return;
    }

    // Open share dialog in a new window
    window.open(shareUrl, "_blank", "width=600,height=400");
  };

  return (
    <div className="flex gap-2 items-center">
      <button onClick={() => handleShare("facebook")} className="p-2 hover:opacity-80 text-blue-600" aria-label="Share on Facebook">
        <FaFacebook size={24} />
      </button>

      <button onClick={() => handleShare("twitter")} className="p-2 hover:opacity-80 text-sky-500" aria-label="Share on X (Twitter)">
        <FaXTwitter size={24} />
      </button>

      <button onClick={() => handleShare("pinterest")} className="p-2 hover:opacity-80 text-red-600" aria-label="Share on Pinterest">
        <FaPinterest size={24} />
      </button>
    </div>
  );
};
